import { canonicalJson, sha256Hex } from '@ml/config';
import type { Board } from './types.ts';

/** Hash tất định của bảng (JSON khoá sắp xếp + SHA-256), dùng cho test determinism/replay. */
export function hashBoard(board: Board): string {
  return sha256Hex(canonicalJson(board));
}

/** Hash một state bất kỳ chỉ gồm dữ liệu JSON (vd. `{ board, rng: rng.state }`). */
export function hashState(state: unknown): string {
  return sha256Hex(canonicalJson(state));
}
